export class ActorPointerEventsController {
  constructor(actorsManager) {
    this.actorsManager = actorsManager;
    this._triggeredNodes = /* @__PURE__ */ new Set();
    this._scene = actorsManager.scene;
  }
  setTriggeredNodes(nodes) {
    nodes.forEach((node) => {
      this._triggeredNodes.add(node);
    });
  }
  runTriggers() {
    this._triggeredNodes.forEach((triggeredNode) => {
      const triggeredNodeParent = this._triggeredNodeParent(triggeredNode);
      if (!triggeredNodeParent) {
        return;
      }
      const nodeParentId = triggeredNodeParent.graphNodeId();
      this._scene.threejsScene().traverse((object) => {
        const nodeIds = this.actorsManager.objectActorNodeIds(object);
        if (!nodeIds) {
          return;
        }
        if (!nodeIds.includes(nodeParentId)) {
          return;
        }
        triggeredNode.receiveTrigger({ Object3D: object });
      });
    });
    this._triggeredNodes.clear();
  }
  _triggeredNodeParent(node) {
    return this.actorsManager.parentActorBuilderNode(node);
  }
}
